import styled from "styled-components";
export const OnlyExtraBookingWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
